import { ChartOptions } from "chart.js"

export const CryptoStocksOptions: ChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        includeBounds: false,
        font: { family: "ChakraPetchRegular", size: 12 },
      },
    },
    y: {
      ticks: {
        includeBounds: false,
        font: { family: "ChakraPetchRegular", size: 12 },
      },
    },
  },
}
